export enum FiduciaryUserTypes
{
    all,
    corporate,
    operational
}